/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserCouponOptionRespVo
 */
export interface GetUserCouponOptionRespVo {
    /**
     * 编号
     * @type {number}
     * @memberof GetUserCouponOptionRespVo
     */
    code?: number;
    /**
     * 名称
     * @type {string}
     * @memberof GetUserCouponOptionRespVo
     */
    name?: string;
}

/**
 * Check if a given object implements the GetUserCouponOptionRespVo interface.
 */
export function instanceOfGetUserCouponOptionRespVo(value: object): value is GetUserCouponOptionRespVo {
    return true;
}

export function GetUserCouponOptionRespVoFromJSON(json: any): GetUserCouponOptionRespVo {
    return GetUserCouponOptionRespVoFromJSONTyped(json, false);
}

export function GetUserCouponOptionRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserCouponOptionRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function GetUserCouponOptionRespVoToJSON(json: any): GetUserCouponOptionRespVo {
    return GetUserCouponOptionRespVoToJSONTyped(json, false);
}

export function GetUserCouponOptionRespVoToJSONTyped(value?: GetUserCouponOptionRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

